import Request from './request';

async function fetch(data) {
    return Request('get', "api/campaigns/index", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/campaigns/view/" + id);
}

async function addCampaign(data) {//创建新的促销活动
    return Request('post', "api/campaigns/add", data);
}

async function editCampaign(data) {//编辑促销活动
    return Request('post', "api/campaigns/edit", data);
}

async function cancel(id) {
    return Request("get", "api/campaigns/cancel/" + id)
}

async function statusUpdate(id) {
    return Request("get", "api/campaigns/status-update/" + id)
}

export default {
    fetch,
    fetchOne,
    addCampaign,
    editCampaign,
    cancel,
    statusUpdate
};